import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const FrptContactEmail = () => {

    const name = fromCharCode(102, 114, 112, 116);
    const domain = fromCharCode(108, 98, 46, 108, 116);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(102, 114, 112, 116, 64, 108, 98, 46, 108, 116)}`}
            </a>
        </>
    )
}

export default FrptContactEmail;
